/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.content.themes.modules.rpc.ActiveThemePresetRpc
 */

/**
 * Record for com.hubspot.chirp.core.CausalChainLink
 */

/**
 * Record for com.hubspot.chirp.core.ChirpMethodCoordinates
 */

export const getByThemePathAndBusinessUnitIdRpc = {
  serviceName: 'com.hubspot.content.themes.modules.rpc.ActiveThemePresetRpc',
  rpcName: 'getByThemePathAndBusinessUnitId',
  auth: 'app',
  fingerprint: '65_WmYbGttxF077DEut0A5wP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const listRpc = {
  serviceName: 'com.hubspot.content.themes.modules.rpc.ActiveThemePresetRpc',
  rpcName: 'list',
  auth: 'app',
  fingerprint: 'UzyQRVHqhh0P8TnwG-Be0JwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const createRpc = {
  serviceName: 'com.hubspot.content.themes.modules.rpc.ActiveThemePresetRpc',
  rpcName: 'create',
  auth: 'app',
  fingerprint: 'fX_G2xkuE7566VGW5y5D_JwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const updateRpc = {
  serviceName: 'com.hubspot.content.themes.modules.rpc.ActiveThemePresetRpc',
  rpcName: 'update',
  auth: 'app',
  fingerprint: 'fX_G2xkuE7566VGW5y5D_JwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const deleteRpc = {
  serviceName: 'com.hubspot.content.themes.modules.rpc.ActiveThemePresetRpc',
  rpcName: 'delete',
  auth: 'app',
  fingerprint: '65_WmYbGttzBIV0pXcghjpwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const pushBufferLiveRpc = {
  serviceName: 'com.hubspot.content.themes.modules.rpc.ActiveThemePresetRpc',
  rpcName: 'pushBufferLive',
  auth: 'app',
  fingerprint: 'GrYmmWVVmcR66VGW5y5D_JwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getBufferRpc = {
  serviceName: 'com.hubspot.content.themes.modules.rpc.ActiveThemePresetRpc',
  rpcName: 'getBuffer',
  auth: 'app',
  fingerprint: 'GrYmmWVVmcR66VGW5y5D_JwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const updateBufferRpc = {
  serviceName: 'com.hubspot.content.themes.modules.rpc.ActiveThemePresetRpc',
  rpcName: 'updateBuffer',
  auth: 'app',
  fingerprint: 'YQgqd8pr97l66VGW5y5D_Pd3p3PJOCBD',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const hasBufferedChangesRpc = {
  serviceName: 'com.hubspot.content.themes.modules.rpc.ActiveThemePresetRpc',
  rpcName: 'hasBufferedChanges',
  auth: 'app',
  fingerprint: 'GrYmmWVVmcT_AMK9WCjTZpwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const pushBufferLiveByThemePathRpc = {
  serviceName: 'com.hubspot.content.themes.modules.rpc.ActiveThemePresetRpc',
  rpcName: 'pushBufferLiveByThemePath',
  auth: 'app',
  fingerprint: '65_WmYbGttx66VGW5y5D_JwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getBufferByThemePathRpc = {
  serviceName: 'com.hubspot.content.themes.modules.rpc.ActiveThemePresetRpc',
  rpcName: 'getBufferByThemePath',
  auth: 'app',
  fingerprint: '65_WmYbGttx66VGW5y5D_JwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const updateBufferByThemePathRpc = {
  serviceName: 'com.hubspot.content.themes.modules.rpc.ActiveThemePresetRpc',
  rpcName: 'updateBufferByThemePath',
  auth: 'app',
  fingerprint: 'C8qSFwHWe7h66VGW5y5D_Pd3p3PJOCBD',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const hasBufferedChangesByThemePathRpc = {
  serviceName: 'com.hubspot.content.themes.modules.rpc.ActiveThemePresetRpc',
  rpcName: 'hasBufferedChangesByThemePath',
  auth: 'app',
  fingerprint: '65_WmYbGttz_AMK9WCjTZpwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};